import { State } from "@/store/modules/sidebar/index";

const getSidebarFull = (state: State): boolean => {
  return state.sidebarFull;
};

const getOpenChat = (state: State): boolean => {
  return state.openChat;
};

const getOpenCall = (state: State): boolean => {
  return state.openCall;
};
const getOpenOtherReason = (state: State): boolean => {
  return state.openOtherReason;
};
const getActiveMenu = (state: State) => {
  return state.activeMenu;
};
const getPowerUpsNotifications = (state: State) => {
  return state.powerUpsNotifications;
};
export default {
  getSidebarFull,
  getOpenChat,
  getOpenCall,
  getOpenOtherReason,
  getActiveMenu,
  getPowerUpsNotifications,
};
